function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  className: "nc-icon-wrapper",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2,
  transform: "translate(0.5 0.5)",
  fill: "#000",
  stroke: "#000"
}, /*#__PURE__*/React.createElement("path", {
  "data-color": "color-2",
  fill: "none",
  strokeMiterlimit: 10,
  d: "M12,16L12,16 c-2.209,0-4-1.791-4-4v-2c0-2.209,1.791-4,4-4h0c2.209,0,4,1.791,4,4v2C16,14.209,14.209,16,12,16z"
}), /*#__PURE__*/React.createElement("path", {
  "data-cap": "butt",
  "data-color": "color-2",
  fill: "none",
  strokeMiterlimit: 10,
  d: "M18.102,21.154 C17.002,19.86,15.332,19,13.5,19h-3c-1.847,0-3.499,0.835-4.6,2.147"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "none",
  stroke: "#000",
  strokeMiterlimit: 10,
  cx: 12,
  cy: 12,
  r: 11
}));

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.c736dd8c.svg";
export { ForwardRef as ReactComponent };